import InstallSuccessPage from './InstallSuccessPage'
export default InstallSuccessPage
